module.exports = __webpack_public_path__ + "img/farming_50.e629267a.png";